import { Quadrilateral } from 'scandit-web-datacapture-core';

var e=class t{get frameID(){return this._frameID}get location(){return this._location}static fromJSON(r){let a=new t;return a._location=Quadrilateral.fromJSON(r.location),a._frameID=r.frameId,a}};

export { e as a };
